/**
 * Utilitário centralizado para geração de iniciais
 * Substitui lógica duplicada em múltiplos componentes
 * 
 * Versão: 1.0.0
 */

/**
 * Extrai iniciais de um nome ou email
 * @param name - Nome completo, email ou texto
 * @param fallback - Caractere padrão quando não há nome
 * @returns String com 1-2 caracteres em maiúsculo
 */
export function getInitials(
  name: string | null | undefined,
  fallback: string = '?'
): string {
  if (!name || name.trim() === '') return fallback;
  
  const trimmed = name.trim();
  
  // Se for email, usa primeira letra antes do @
  if (trimmed.includes('@')) {
    return trimmed.charAt(0).toUpperCase();
  }
  
  // Se for apenas números (telefone), retorna fallback
  // Se for apenas números (telefone), retorna primeiro dígito como inicial
  if (/^[\d\s\-\+\(\)]+$/.test(trimmed)) {
    const firstDigit = trimmed.match(/\d/);
    return firstDigit ? firstDigit[0] : fallback;
  }
  
  // Extrai primeiras letras de cada palavra (máximo 2)
  return trimmed
    .split(/\s+/)
    .filter(Boolean)
    .map(word => word[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}
